/**
 * D1 Store: Contact options panel (contact-for-availability PDP state)
 */
(function () {
  'use strict';

  var panel = null;
  var lastFocus = null;

  function getPanel() {
    if (!panel) panel = document.getElementById('D1ContactOptions');
    // Parents with transform (scroll-reveal) trap position:fixed — keep on <body>
    if (panel && panel.parentElement !== document.body) {
      document.body.appendChild(panel);
    }
    return panel;
  }

  function setTawkVisible(visible) {
    try {
      if (visible) return;
      if (window.Tawk_API && typeof window.Tawk_API.hideWidget === 'function') {
        window.Tawk_API.hideWidget();
      }
    } catch (_) {}
  }

  function maximizeTawk() {
    if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') {
      window.Tawk_API.maximize();
      return true;
    }
    return false;
  }

  function openLiveChat() {
    setTawkVisible(true);
    if (maximizeTawk()) return;
    if (window.Tawk_API) {
      var prevOnLoad = window.Tawk_API.onLoad;
      window.Tawk_API.onLoad = function () {
        if (typeof prevOnLoad === 'function') prevOnLoad();
        maximizeTawk();
      };
    }
    setTimeout(maximizeTawk, 400);
  }

  function openPanel() {
    var el = getPanel();
    if (!el) return;
    lastFocus = document.activeElement;
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTawkVisible(false);
    var closeBtn = el.querySelector('.d1-contact-options__close');
    if (closeBtn) closeBtn.focus();
  }

  function closePanel() {
    var el = getPanel();
    if (!el || el.getAttribute('aria-hidden') === 'true') return;
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTawkVisible(true);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    getPanel(); // move to body early so it never paints inside the buy box
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-d1-open-contact-options]')) {
      event.preventDefault();
      openPanel();
      return;
    }

    if (event.target.closest('[data-d1-contact-options-close]')) {
      event.preventDefault();
      closePanel();
      return;
    }

    if (event.target.closest('[data-d1-contact-chat]')) {
      event.preventDefault();
      closePanel();
      openLiveChat();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var el = getPanel();
    if (!el || el.getAttribute('aria-hidden') === 'true') return;
    closePanel();
  });
})();
